import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import {
	IMilkingTableRequest,
	IMilkingTableResponse,
} from 'components/milk-yield/components/MilkYeild-Table/components/IMilkingTableResponse'
import { useEffect } from 'react'
import CattlesApiService from 'services/cattlesApiServices'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'
import { getErrorMessage } from 'utils/getErrorMessage/getErrorMessage'

export const useGetMilkingTableData = (params: IMilkingTableRequest) => {
	const { page, page_size, ...restParams } = params
	const dispatch = useAppDispatch()
	const { data, error, isError, ...rest } = useQuery<
		IMilkingTableResponse,
		AxiosError
	>({
		queryKey: ['milking-table-data', restParams, page, page_size],
		queryFn: async () => {
			return await CattlesApiService.getMilkYieldTableData({
				...restParams,
				page,
				page_size,
			})
		},
		staleTime: 30000,
		retry: 3,
	})

	useEffect(() => {
		if (isError || error) {
			const errorMsg =
				getErrorMessage(error?.response?.data) ||
				error.message ||
				'Попробуйте позже'
			dispatch(
				notifyUser({
					title: 'Ошибка при загрузке надоев',
					description: errorMsg,
					isError: true,
				}),
			)
		}
	}, [isError, error, dispatch])

	return {
		list: data?.results ?? [],
		totalCount: data?.count ?? 0,
		...rest,
	}
}
